/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExamDto,
} from '../models/index';
import {
    ExamDtoFromJSON,
    ExamDtoToJSON,
} from '../models/index';

export interface ApiExamByShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

/**
 * 
 */
export class ExamApi extends runtime.BaseAPI {

    /**
     */
    async apiExamByShowShowIdBookerBookerIdGetRaw(requestParameters: ApiExamByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExamDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiExamByShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiExamByShowShowIdBookerBookerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Exam/ByShow/{showId}/booker/{BookerId}`.replace(`{${"showId"}}`, encodeURIComponent(String(requestParameters['showId']))).replace(`{${"BookerId"}}`, encodeURIComponent(String(requestParameters['bookerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExamDtoFromJSON));
    }

    /**
     */
    async apiExamByShowShowIdBookerBookerIdGet(requestParameters: ApiExamByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExamDto>> {
        const response = await this.apiExamByShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
